import variables from '../../variables';
import Model from '../classes/Model';
import {$events} from '../../helpers/events';
import {$dom} from '../../helpers/dom';
import SmoothScrollbar from 'smooth-scrollbar';
import {createElementFromHTML, loop} from '../../helpers/_utilities';

const {
	getAll,
	get,
	callAll,
	attr,
	remove,
	each
} = $dom;

export default class ModalAddressChoice extends Model {
	constructor(options = {}) {

		super(options);

		this.regionsFieldWrapSelector =   '.js-address-choice-region';
		this.regionsSelector =            `${this.regionsFieldWrapSelector} input`;

		this.localityFieldWrapSelector =  '.js-address-choice-locality';
		this.localitySelector =           `${this.localityFieldWrapSelector} input`;

		this.searchLitsSelector =         '.js-address-search-list';
		this.searchRemoveItemSelector =   '.js-address-search-remove';

		this.idAttr =                     'data-search-id';

		this.searchListItemIdAttr =       'data-list-item-id';
		this.searchListItemSelector =     `[${this.searchListItemIdAttr}]`;

		this.searchItemTemplate =         get('#js-address-search-item-template', this.rootEl).innerHTML;

		this.fieldSelector =              '.js-catalog-filter-territory-field input';

		this.searchSelected = [];

		this.updateScrollbars = this.updateScrollbars.bind(this);
		this.handleChanges = this.handleChanges.bind(this);
		this.processRegion = this.processRegion.bind(this);
		this.processLocality = this.processLocality.bind(this);
		this.printSearchItems = this.printSearchItems.bind(this);
		this.removeSearchItem = this.removeSearchItem.bind(this);
		this.checkEmpty = this.checkEmpty.bind(this);
		this.changeTab = this.changeTab.bind(this);
	}

	get scrollbars() {
		return getAll(variables.selectors.smoothScrollbarTarget, this.rootEl).map(s => SmoothScrollbar.get(s))
	}

	updateScrollbars() {
		loop(this.scrollbars, s => {
			if (s instanceof SmoothScrollbar)
				s.update();
		})
	}

	processRegion(input) {
		const {searchValue} = input.dataset;
		if (searchValue && input.checked) {
			this.searchSelected[0] = {
				input,
				id: attr(input, this.idAttr)
			};

			this.printSearchItems()
		}

	}

	processLocality(input) {
		const {searchValue} = input.dataset;

		if (searchValue) {

			let item = {
				input,
				id: attr(input, this.idAttr)
			};

			const indexOf = this.searchSelected.map(i => i.id).indexOf(item.id);

			if (indexOf === -1 && input.checked) {
				this.searchSelected.push(item);
			} else {
				if (indexOf >= 0) {
					this.searchSelected.splice(indexOf, 1);
				}
			}

			this.printSearchItems()
		}

	}

	checkEmpty() {
		$dom[this.searchSelected.length > 0 ? 'addClass' : 'removeClass'](this.searchList, 'is-not-empty');
	}

	removeSearchItem(event) {
		const searchItem = event.target.closest(this.searchListItemSelector);
		const boundSelectedItem = this.searchSelected.filter(e => e.id === attr(searchItem, this.searchListItemIdAttr))[0];
		const {input} = boundSelectedItem;

		this.searchSelected.splice(this.searchSelected.indexOf(boundSelectedItem), 1);
		input.checked = false;
		remove(searchItem);

		this.checkEmpty();
	}

	handleChanges(event) {
		const {target} = event;

		if (target.closest(this.regionsSelector)) {
			this.processRegion(target)
		}

		if (target.closest(this.localitySelector)) {
			this.processLocality(target)
		}
	}

	printSearchItems() {

		this.searchList.innerHTML = '';
		get(this.fieldSelector).value = '';

		if (variables.windowWidth > variables.breakpoints.md) {
			loop(this.searchSelected, item => {

				let template =
					this.searchItemTemplate
						.replace('{{name}}', item.input.dataset.searchValue)
						.replace('{{id}}', item.id)
				;

				this.searchList.appendChild(createElementFromHTML(template));
			});

			this.checkEmpty()
		}

		get(this.fieldSelector).value =
			this.searchSelected
				.filter(({input}) => input.closest(this.localityFieldWrapSelector))
				.map(({input}) => input.dataset.searchValue)
				.join(', ')
				.trim()
		;
	}

	listeners(action) {
		switch (action) {
			case 'add':

				$events.delegate
					.on('input', `#${this.options.rootElementId}`, this.handleChanges)
					.on('click tap', this.searchRemoveItemSelector, this.removeSearchItem)
					.on(variables.customEventNames.modal.opened, `#${this.options.rootElementId}`, this.updateScrollbars)
					.on("change", this.regionsSelector, this.changeTab)
				;

				break;
			case 'remove':
				$events.delegate
					.off('input', `#${this.options.rootElementId}`, this.handleChanges)
					.off('click tap', this.searchRemoveItemSelector, this.removeSearchItem)
					.off(variables.customEventNames.modal.opened, `#${this.options.rootElementId}`, this.updateScrollbars)
				;
				break;
		}
	}

	changeTab({target}){
		let value = target.value;
		let modalChoices = getAll(".js-modal__choice-settlements");
		each(modalChoices,el => {
			el.style.display = "none";
		});
		let modalChoice = get(".js-modal__choice-settlements[data-id='" + target.value + "']");
		modalChoice.style.display = "block";
	}

	init() {

		this.searchList = get(this.searchLitsSelector, this.rootEl);

		callAll(this.regionsSelector, this.processRegion, this.rootEl);
		callAll(this.localitySelector, this.processLocality, this.rootEl);

		this.listeners('add');
		super.init();
	}

	destroy() {
		this.listeners('remove');
		super.destroy();
	}

}
